"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasContact = hasContact;
exports.hasPrice = hasPrice;
function hasContact(event) {
  return event.contact_name || event.contact_phone || event.contact_email || event.contact_url;
}

function hasPrice(event) {
  return event.price_type || event.price_notes || event.prices.length > 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/helpers/event.js
// module id = 684
// module chunks = 0